import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Segment } from '~src/interfaces/segment.interface';

import { getNameOfSegment } from '~src/services/getNameOfSegment';
import AvatarBox from '~src/shared/avatarBox/AvatarBox';
import SvgIcon from '~src/shared/SvgIcon';

import { CloseIcon, CustomChipContainer } from './PeopleChips.sc';
import { Tooltip } from 'antd';

interface Props {
  value: Segment & HasSegmentRemoveHandler;
  locked?: boolean;
  tooltipText?: string;
}

export type HasSegmentRemoveHandler = {onRemove?: (s: Segment) => void};

const CustomChip: FC<Props> = ({ value, locked, tooltipText }) => {
  const [t] = useTranslation();
  const onItemClick = () => {
    if (value.onRemove) {
      value.onRemove(value);
    }
  };
  return tooltipText ? (
    <Tooltip placement="top" title={tooltipText}>
      <CustomChipContainer $locked={locked}>
        <AvatarBox
          type={value.type}
          name={getNameOfSegment(t, value) || undefined}
          url={value.image_url}
          size={25}
        />
        <span>{getNameOfSegment(t, value)}</span>
        {!locked && (
          <CloseIcon onClick={onItemClick}>
            <SvgIcon width="15px" name="iconCrossInCircle" />
          </CloseIcon>
        )}
      </CustomChipContainer>
    </Tooltip>
  ) : (
    <CustomChipContainer $locked={locked}>
      <AvatarBox
        type={value.type}
        name={getNameOfSegment(t, value) || undefined}
        url={value.image_url}
        size={25}
      />
      <span>{getNameOfSegment(t, value)}</span>
      {!locked && (
        <CloseIcon onClick={onItemClick}>
          <SvgIcon width="15px" name="iconCrossInCircle" />
        </CloseIcon>
      )}
    </CustomChipContainer>
  );
};

export default React.memo(CustomChip);
